interface HiringThemeWrapperProps {
  children: React.ReactNode;
  fullPage?: boolean;
}

/**
 * Wraps hiring tool pages with the .hiring-theme CSS class so they render
 * with the exact same design as the standalone hiring-tool repo:
 * - Hot pink (#FB3AAE) primary color
 * - 0.3rem border radius
 * - Inter font
 */
export function HiringThemeWrapper({ children, fullPage = false }: HiringThemeWrapperProps) {
  if (fullPage) {
    return (
      <div className="hiring-theme min-h-screen">
        {children}
      </div>
    );
  }
  return (
    <div className="hiring-theme">
      {children}
    </div>
  );
}
